<template functional>
    <SfIcon :icon="injections.imports.icons[props.icon].path" :view-box="injections.imports.icons[props.icon].viewBox" />
    <!-- <component :is="injections.components.SfIcon" :icon="injections.components.icons[props.icon].path" :view-box="injections.components.icons[props.icon].viewBox" /> -->
</template>

<script>
import icons from "@/utils/icons";
import { SfIcon } from '@storefront-ui/vue';

export default {
    name: "OrkSvgIcon",
    inject: {
        components: {
            default: {
                SfIcon
            },
        },
        imports: {
            default: {
                icons
            },
        },
    },
    props: {
        icon: String
    }
}
</script>